import ContactSupport from "./contact-support";
import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";
import states from "../states";

export default pure(function DisallowedMessage({ session, subtle }) {
  var hasFailedIdVerification = session.get("identity_verified") === false && session.get("identity_verification_transaction_id") !== null;
  var canDeposit = session.get("abilities").contains("make deposits");
  var canWithdraw = session.get("abilities").contains("make withdrawals");

  if (!hasFailedIdVerification && (canDeposit && canWithdraw)) {
    return null;
  }

  var actions = [];
  if (!canDeposit) {
    actions.push("Deposits");
  }
  if (!canWithdraw) {
    actions.push("Withdrawals");
  }
  if (hasFailedIdVerification) {
    actions.push("ID Verification");
  }
  var actionList = actions.join(" and ");

  var fullMessage = "";
  var extraButtons;
  if (hasFailedIdVerification) {
    fullMessage = "Alert! ID Verification Failure.";
  } else {
    var state = session.getIn(["billing_address", "state"]);
    var fullState = "your";
    var stateInfo = states.filter(s => s.abbr === state)[0];
    if (stateInfo !== undefined) {
      fullState = stateInfo.name;
    }
    fullMessage = `Sorry, ${actionList} are not permitted by ${fullState} state residents.`;

    if (!canDeposit && canWithdraw) {
      extraButtons = (
        <span>
          <span>
            {" "}
            or

            {" "}
          </span>

          <Link className="btn btn--transparent" to="/withdraw">
            Withdraw
          </Link>
        </span>
      );
    }
  }

  return (
    <ContactSupport extraButtons={extraButtons} isError={hasFailedIdVerification} message={fullMessage} subtle={subtle} />
  );
});
